import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import PrimeVue from 'primevue/config';
import Aura from '@/presets/aura'
import router from './router';

import "vue-fast-marquee/style.css";
import VueSplide from '@splidejs/vue-splide';

import { Icon } from '@iconify/vue';


import AnimateOnScroll from 'primevue/animateonscroll';

import { VueQueryPlugin } from '@tanstack/vue-query'

import { createHead } from '@vueuse/head'
import { createGtag } from 'vue-gtag'

import VueLazyload from 'vue-lazyload'


const app = createApp(App);
const head = createHead()

app.directive('animateonscroll', AnimateOnScroll);

const gtag = createGtag({
    tagId: import.meta.env.VITE_GA_ID,         
    vueRouter: router,              
    enabled: import.meta.env.PROD   
})
app.component('Icon', Icon);
app.use(PrimeVue, {
    unstyled: true,
    pt: Aura                               
}).use(router).use(VueSplide).use(VueQueryPlugin).use(head).use(gtag)


app.use(VueLazyload, {
    preLoad: 1.3,
    // No loading image - we use skeleton instead
    attempt: 3, // retry attempts
    listenEvents: ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove'],
    observer: true, // use IntersectionObserver
    observerOptions: {
      rootMargin: '0px',
      threshold: 0.1
    }
  })
app.mount('#app')